export function namespaceTitle({ name }: { name: string }): string {
  return name;
}
